var _path, _path2, _rect, _polygon, _polygon2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _rect3, _rect4, _rect5, _polygon3, _path9, _path0, _path1, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle2, _path17, _path18, _path19, _path20, _circle3, _path21, _circle4, _circle5, _circle6, _circle7, _circle8, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgOnboardingWelcomeBackground = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ab41ebfa-be58-42b9-8177-2e0969874e06",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1136,
    height: 691.42321,
    viewBox: "0 0 1136 691.42321",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "positive_attitude") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M823.78018,435.77908s-45.69824-9.25534-39.91366,10.41226,43.96287,6.9415,43.96287,6.9415Z",
    transform: "translate(-32 -104.28839)",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M922.36835,331.89512a4.28712,4.28712,0,0,1,7.11069,2.45006l1.56238,9.07177s7.06078,36.28651,1.015,59.33622-10.33675,53.41177-26.67486,56.64624c-13.98067,2.76776-67.13865-1.61523-82.188-2.93771a4.28346,4.28346,0,0,1-3.90658-4.36407l.28148-13.24036a4.28991,4.28991,0,0,1,3.834-4.17454l60.86186-6.49086a4.28115,4.28115,0,0,0,3.79252-3.66409c1.44766-10.35447,6.129-42.4559,10.77887-59.33362C902.5931,351.55582,914.934,338.67907,922.36835,331.89512Z",
    transform: "translate(-32 -104.28839)",
    fill: "#575a89"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 716,
    y: 668.25283,
    width: 420,
    height: 2,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "850.822 614.608 850.822 642.374 866.44 645.844 876.853 640.638 875.696 618.657 850.822 614.608",
    fill: "#ffb8b8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "943.086 614.608 943.086 642.374 958.705 645.844 969.117 640.638 967.96 618.657 943.086 614.608",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M914.05888,493.29719s-20.82451,42.22749-20.24606,75.19964a452.25861,452.25861,0,0,1-2.89229,59.58125l-10.41226,98.91645,33.55061,1.73538L929.67727,622.2935l30.07985-82.14115,11.56918,97.75953,2.89229,98.338h28.92294s13.30455-93.13186,5.78459-113.95637c0,0,17.35376-116.84867,3.47075-122.63326S914.05888,493.29719,914.05888,493.29719Z",
    transform: "translate(-32 -104.28839)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M893.23437,739.14216s-5.78459-21.403-13.883-10.41225-31.23678,29.50139-31.23678,29.50139-34.70752,18.51068-2.89229,23.13835,35.286-5.78458,35.286-5.78458,5.20613-2.8923,9.8338-1.15692,24.87373,1.15692,26.03065-5.78459-6.363-45.11978-8.67688-38.17828S893.23437,739.14216,893.23437,739.14216Z",
    transform: "translate(-32 -104.28839)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M999.67078,738.5637s0-6.363-10.99072-6.9415-12.72609,6.9415-12.72609,6.9415-2.8923,2.8923-3.47075,11.56918,0,31.23677,0,31.23677-5.20613,17.35377,18.51068,13.883,15.03992-21.403,15.03992-21.403Z",
    transform: "translate(-32 -104.28839)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M957.44329,277.53208l-2.8923,32.39369-5.20612,12.14763,13.883,19.6676,34.12906-31.81523s-6.363-17.35376-2.31383-27.18756Z",
    transform: "translate(-32 -104.28839)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.95676,333.06412l-.2661,2.85176L1024.5445,444.1282s-.39913,5.03256-1.13954,11.74274c-1.24949,11.34929-3.47076,27.49409-6.38042,32.22012-4.62767,7.52-1.15692,13.883-1.15692,13.883-26.6091,15.61839-105.27949-6.9415-105.27949-6.9415l17.93222-71.72889S912.32351,348.6825,914.05888,341.741s38.17828-31.81523,38.17828-31.81523l1.07592,2.89229c15.53164,20.82452,31.31777,2.8923,35.94544-1.15692l9.25534-8.09842Z",
    transform: "translate(-32 -104.28839)",
    fill: "#575a89"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M916,531.54123c-55.14925,7.48169-107.76156,10.22061-156.44473,5.614a377.43922,377.43922,0,0,1-51.31664-8.81222c-30.95486-7.32718-68.95236-7.327-110.69916-3.426a317.73935,317.73935,0,0,0-74.51442,15.8037c-32.352,11.199-67.79317,10.22925-105.368.85435A192.172,192.172,0,0,1,373.41473,523.959c-27.47036-14.762-59.9816-9.41723-95.41473,7.58225v-132c33.08053-14.40681,65.30687-16.73252,96.51-4.58755a203.87829,203.87829,0,0,0,35.14088,10.4829,276.99137,276.99137,0,0,0,130.55219-5.89535c57.36872-19.43848,117.37882-13.39581,178.15115,0,67.707,14.30069,133.6965,15.14407,197.64577,0Z",
    transform: "translate(-32 -104.28839)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 668.25283,
    width: 420,
    height: 2,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 540.25171,
    y: 110.96262,
    width: 36.46865,
    height: 36.46865,
    transform: "translate(1074.74759 -142.44663) rotate(150)",
    fill: "#ff6584"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 423.25171,
    y: 269.96262,
    width: 36.46865,
    height: 36.46865,
    transform: "translate(935.92262 212.75141) rotate(150)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 744.25171,
    y: 227.96262,
    width: 36.46865,
    height: 36.46865,
    transform: "translate(1513.91678 -26.12166) rotate(150)",
    fill: "#d0cde1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.85 423.599 197.947 512.01 139.949 642.15 173.899 657.004 238.969 507.766 197.372 376.702 172.617 383.068 178.85 423.599",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.87512,503.57817s7.07288,12.73118,22.63321,23.34049,48.09556,80.63079,48.09556,80.63079L229.23951,749.007l48.80284,13.43847,26.87693-166.2126L249.75085,471.75023Z",
    transform: "translate(-32 -104.28839)",
    fill: "#2f2e41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M176.19293,741.48784s-7.07287,7.78017-4.24372,13.43847,4.24372,20.51134,4.24372,20.51134h6.36559v-16.9749l20.51134,19.09676s47.38828,4.24373,46.681,0-28.29151-14.14575-28.29151-14.14575l-13.43846-20.51134Z",
    transform: "translate(-32 -104.28839)",
    fill: "#2f2e41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M238.43425,743.34868s-7.07288,7.78016-4.24373,13.43847,4.24373,20.51134,4.24373,20.51134h6.36558V760.32358l20.51135,19.09677s47.38827,4.24373,46.681,0-28.29151-14.14575-28.29151-14.14575l-13.43846-20.51134Z",
    transform: "translate(-32 -104.28839)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 189.45934,
    cy: 178.61603,
    r: 26.87693,
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M199.53343,284.319s-2.12187,26.87693-15.56033,36.779-13.43847,18.38948-13.43847,18.38948l54.46115,24.75506L212.2646,337.36557s-3.53644-1.41457,2.12187-8.48745,10.60931-24.04778,10.60931-24.04778Z",
    transform: "translate(-32 -104.28839)",
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M255.05551,474.933l0,0a152.336,152.336,0,0,1-50.21861,29.1511L192,508.54123s-27.14491-32.94336-13.43767-58.90082a40.66524,40.66524,0,0,1,11.77636-13.96185l-.28294-1.23776-6.88189-30.02437-.61534-2.68768-20.51134-4.951s-.06372.02119-.1839.04951c-1.53476.40316-11.939,2.3128-4.05983-21.97543,5.24158-16.16153,9.04213-31.54934,11.18243-40.95523a9.98259,9.98259,0,0,1,12.34516-7.43944c6.568,1.80094,14.727,5.22118,19.617,11.61571,9.19474,12.02389,11.052-.53163,11.052-.53163s25.727,28.82314,24.31238,41.55431a50.59908,50.59908,0,0,0,.31117,10.24152v.01415c.16974,1.51361.37488,3.09085.60834,4.70344,1.75406,11.91074,5.14908,25.75237,6.39391,30.61851.09186.34657.16974.65069.23329.90531.14859.58706.23346.90535.23346.90535Z",
    transform: "translate(-32 -104.28839)",
    fill: "#575a89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.63019,439.215l-5.6583,19.09677s-21.69954-5.531-34.40956-8.67135a40.66524,40.66524,0,0,1,11.77636-13.96185l-.28294-1.23776-6.88189-30.02437-.61534-2.68768-20.51134-4.951s-.06372.02119-.1839.04951l-1.23067-9.24425s35.36438,2.12186,37.48624,10.60931-2.12186,16.9749-4.24373,18.38948,0,0,4.24373,2.12186-1.41458,0-4.24373,4.24373.70729.70729,1.41458,2.82915,0-.70729-.70729,2.82915,2.82915.70729,3.53644.70729S218.63019,439.215,218.63019,439.215Z",
    transform: "translate(-32 -104.28839)",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M212.2646,435.67856l45.9737,12.02389s24.75507-25.46236,38.19353-17.6822-24.04778,25.46236-24.04778,25.46236l-13.43846,2.82915-48.80285-5.6583Z",
    transform: "translate(-32 -104.28839)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.63261,384.75385l2.82915,21.21862s-2.12187,0,0,4.951,0,14.853,0,14.853-4.24373.70729-.70729,2.82915,7.07287,7.78016,5.6583,9.902-4.24373,4.951,2.12186,6.36558,42.43726,10.60932,42.43726,10.60932l5.6583-19.09677s-19.804-9.902-20.51134-9.902-4.24373,2.82915-3.53644-.70729,1.41458-.70729.70729-2.82915-4.24373,1.41457-1.41458-2.82915,8.48746-2.12187,4.24373-4.24373-6.36559-.70729-4.24373-2.12186,6.36559-9.902,4.24373-18.38948S160.63261,384.75385,160.63261,384.75385Z",
    transform: "translate(-32 -104.28839)",
    fill: "#575a89"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M215.26107,330.40153l2.13136-3.3889a7.07482,7.07482,0,0,0-2.22234-9.75535l-16.239-10.21315a7.07481,7.07481,0,0,0-9.75536,2.22226l-2.13137,3.38889a7.063,7.063,0,0,0-6.01415,3.30151l-5.24422,8.33838a7.07483,7.07483,0,0,0,2.2223,9.75539l21.88235,13.76238a7.07484,7.07484,0,0,0,9.7554-2.22231l5.24422-8.33838A7.063,7.063,0,0,0,215.26107,330.40153Z",
    transform: "translate(-32 -104.28839)",
    fill: "#575a89"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M220.52289,282.44236c1.50356-2.196.8445-5.24735,1.92059-7.68149,1.68981-3.82237,6.67287-4.60671,10.84452-4.85816a31.96362,31.96362,0,0,1,8.30577.22341,7.97453,7.97453,0,0,1,5.65962,4.31631c.586,1.25019.52434-2.62392.25008-7.60182a24.02288,24.02288,0,0,0-17.89773-21.9314q-.08772-.02288-.17388-.045c-5.0404-1.29207-10.24595-2.27916-15.427-1.79735s-10.38458,2.58726-13.70766,6.59128c-1.5188,1.83-2.61408,4.00487-4.30064,5.68154-2.96327,2.94589-7.27454,3.93953-11.24426,5.24357a33.53367,33.53367,0,0,0-12.3532,6.73375,18.17568,18.17568,0,0,0-6.1915,12.3443c-.21662,5.50806,3.15074,11.27939,8.77235,12.50252a6.34292,6.34292,0,0,1,2.68006,1.23439c5.2916,4.312-.96628,8.54029-1.03765,13.24867-.05955,3.92882,4.25119,6.59474,8.17059,6.87293a15.81419,15.81419,0,0,0,16.04906-12.12778c.6696-3.20921.293-6.5311-.013-9.79511-.35028-3.73628,7.8854-12.31458,2.42975-6.01285a9.22446,9.22446,0,0,0-2.12959,4.21739c-1.00651,5.11547,3.6262,6.95655,6.50508,9.87428a12.21806,12.21806,0,0,1,2.6522,12.64429,14.08614,14.08614,0,0,0,2.99006-17.72088c-.91431-1.47931-2.10706-2.77589-2.97152-4.28486-1.34892-2.35461-1.61417-7.41144,2.31537-7.17758C215.42519,283.30368,218.28463,285.71137,220.52289,282.44236Z",
    transform: "translate(-32 -104.28839)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 945.11089,
    cy: 159.36067,
    r: 29.5014,
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.53374,337.0728l-10.14615,108.21232s-.39914,5.03256-1.13955,11.74274c-21.536,5.14822-81.0016,9.08177-81.0016,9.08177l-2.89229-20.82451,65.9443-17.93223s-8.09843-45.11978,1.15691-63.63046a143.111,143.111,0,0,0,6.073-13.83991,20.079,20.079,0,0,1,22.00536-12.80973Z",
    transform: "translate(-32 -104.28839)",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M944.7172,442.39282s-45.69825-9.25534-39.91366,10.41226,43.96287,6.94151,43.96287,6.94151Z",
    transform: "translate(-32 -104.28839)",
    fill: "#ffb8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.02454,330.17182l17.93222,2.8923s12.72609,34.70752,10.41226,58.42433-1.73538,54.37513-17.35376,60.15971-85.6119,10.41226-85.6119,10.41226l-2.89229-20.82451,65.94429-17.93223s-8.09842-45.11978,1.15692-63.63046S1017.02454,330.17182,1017.02454,330.17182Z",
    transform: "translate(-32 -104.28839)",
    fill: "#575a89"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M951.95766,233.68561l-5.67026-2.27006s11.856-13.05277,28.35139-11.91769l-4.63943-5.10766s11.34053-4.54,21.65009,7.37765c5.41954,6.26485,11.69,13.6289,15.599,21.92439h6.07247l-2.53442,5.5805,8.87047,5.58051-9.10467-1.00238a31.18426,31.18426,0,0,1,.24707,9.25631,11.97636,11.97636,0,0,1-4.38563,7.83473h0s-7.03216-14.55589-7.03216-16.826v5.67512s-5.67027-5.10759-5.67027-8.51263l-3.09284,3.97258H969.99936l3.09284-5.10758-11.856,1.70252,4.63943-6.24266-18.35634,25.77812S937.00881,242.19824,951.95766,233.68561Z",
    transform: "translate(-32 -104.28839)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 565,
    cy: 363.25283,
    r: 108,
    fill: "#f9a826"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M650,489.00668c0,6.62741-24.33348,23.25-52.5,23.25s-49.5-16.62259-49.5-23.25,21.33348,2.25,49.5,2.25S650,482.37926,650,489.00668Z",
    transform: "translate(-32 -104.28839)",
    fill: "#d0cde1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 332.25283,
    r: 12,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 526,
    cy: 332.25283,
    r: 12,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 533,
    cy: 326.25283,
    r: 6,
    fill: "#d0cde1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 326.25283,
    r: 6,
    fill: "#d0cde1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 567,
    cy: 219.25283,
    r: 43,
    fill: "#f9a826"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M585.19059,327.99224c15.1858,9.04049,15.73093,36.13223,15.73093,36.13223s-24.07591,12.43422-39.26172,3.39374S545.92887,331.386,545.92887,331.386,570.00479,318.95176,585.19059,327.99224Z",
    transform: "translate(-32 -104.28839)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M638.91643,362.61591c-13.72408,11.135-39.34088,2.301-39.34088,2.301s-3.36567-26.8874,10.35841-38.02241,39.34089-2.301,39.34089-2.301S652.64052,351.4809,638.91643,362.61591Z",
    transform: "translate(-32 -104.28839)",
    fill: "#3f3d56"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOnboardingWelcomeBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/onboarding-welcome-background.d8e399e9611b4a20667c4686dec38d47.svg";